module.exports = __webpack_public_path__ + "media/images/countrysquared/mr-39e8e2e37f340841da49d25f5e41f151.svg";